/**
 * MUI theme shadows configuration following Chakra UI naming convention:
 * @description Array of shadow values for different elevation levels
 *
 * Index mapping to Chakra UI names:
 * - [0] = "none"
 * - [1] = "xs" (0 1px 12px 0 rgba(0, 0, 0, 0.1))
 * - [2] = "sm" (0 4px 16px 0 rgba(0, 0, 0, 0.12))
 * - [3] = "base" (0 8px 24px 0 rgba(0, 0, 0, 0.12))
 * - [4] = "md" (0 8px 24px 0 rgba(0, 0, 0, 0.15))
 * - [5] = "lg" (0 16px 32px 0 rgba(0, 0, 0, 0.15))
 * - [6] = "xl" (0 24px 48px 0 rgba(0, 0, 0, 0.15))
 * - [7-24] = "none"
 */
import { ThemeOptions } from "@mui/material/styles";

export const shadows: ThemeOptions["shadows"] = [
    "none",
    "0 1px 12px 0 rgba(0, 0, 0, 0.1)",
    "0 4px 16px 0 rgba(0, 0, 0, 0.12)",
    "0 8px 24px 0 rgba(0, 0, 0, 0.12)",
    "0 8px 24px 0 rgba(0, 0, 0, 0.15)",
    "0 16px 32px 0 rgba(0, 0, 0, 0.15)",
    "0 24px 48px 0 rgba(0, 0, 0, 0.15)",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
    "none",
];

// TODO: rethink this shadow
export const themeShadows = {
    focusVisible: "0 0 0 2px #333333",
};
